import { Post } from '@asset-metrix/portal-ui';

import { FullScreenFrame } from './FullScreenFrame';

export const FullScreenLoader = () => {
  return (
    <FullScreenFrame loading>
      <Post>
        <h1>Loading portal data</h1>
      </Post>
    </FullScreenFrame>
  );
};
